export default __webpack_public_path__ + "static/media/Group781.07b56f3c.svg";